import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IAdminFleetState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const roleModule: Module<IAdminFleetState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default roleModule
